<template>
    <div class="bind_gameacc_pop">
        <div class="header">
            账号验证
            <van-icon name="cross" color="#fff" @click="close"/>
        </div>
        <div class="content">
            <el-form :model="actionData" ref="form" :rules="rules" @submit.native.prevent>
                <el-form-item prop="password" key="password" :rules="rules.password">
                    <p>游戏密码验证</p>
                    <div class="ipt">
                        <el-input v-model="actionData.password" :type="showPassword ? 'text' : 'password'" placeholder="请输入密码" ref="password"></el-input>
                        <i class="iconfont icon-eye" :class="{'icon-eye-close': showPassword}" @click="showPassword = !showPassword"></i>
                    </div>
                </el-form-item>
                <el-form-item prop="real_name" key="real_name" :rules="rules.real_name">
                    <p>游戏实名信息验证</p>
                    <div class="ipt">
                        <el-input v-model="actionData.real_name" placeholder="请输入姓名" ref="real_name"></el-input>
                    </div>
                </el-form-item>
                <el-form-item prop="id_card" key="id_card" :rules="rules.id_card">
                    <div class="ipt">
                        <el-input v-model="actionData.id_card" placeholder="请输入身份证号" ref="id_card"></el-input>
                    </div>
                </el-form-item>
            </el-form>
            <el-button class="confirm" type="primary" @click="bindGameacc" :disabled="actionData.password.length == 0 || actionData.real_name.length == 0 || actionData.id_card.length == 0" :loading="loading > 0">确认</el-button>
        </div>        
    </div>
</template>
<script>
export default {
    data() {
        return {
            actionData: {
                password: '',
                real_name: '',
                id_card: ''
            },
            rules: {
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                real_name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                id_card: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                    { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号', trigger: 'blur' }
                ]
            },
            showPassword: false,
            loading: 0
        }
    },
    methods: {
        close() {
            this.$emit('closeModal')
        },
        bindGameacc() {
            var that = this
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading++;
                    this.$Ajax('v2/user/check-account', {
                        app_id: this.selection.app_id,
                        platform_id: this.selection.platform_id,
                        account: this.selection.account,                    
                        password: this.actionData.password,
                        real_name: this.actionData.real_name,
                        id_card: this.actionData.id_card,
                        user_id: this.selection.user_id
                    }).then(rs => {
                        this.$toast({
                            message: rs.msg,
                            zIndex: 100000,
                        });
                        if(rs.code == 200) {
                            this.$emit('closeModal')
                            this.$emit('success',{
                                game_account: rs.data.game_account,
                                account: rs.data.account
                            })
                        }
                    }).finally(() => {
                        setTimeout(() => {
                          that.loading = 0;
                        }, 2000);
                    });
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.bind_gameacc_pop {
    .header {
        text-align: center;
        height: 3.6rem;
        line-height: 3.6rem;
        background-color: #F66F30;
        color: #fff;
        position: relative;
        font-size: 1.6rem;
        font-weight: 700;
        .van-icon {
            font-size: 1.6rem;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: .8rem;
            cursor: pointer;
        }
    }
    .content {
        padding: 1.6rem 1.5rem 1.9rem;
        .el-form-item {
            margin-bottom: 1.8rem;
        }
        /deep/.el-form-item__content {
            line-height: 1;
        }
        p {
            font-size: 1.6rem;
            margin-bottom: .7rem;
        }
        ::v-deep.el-input__inner {
            height: 4rem;
            border: none;
            outline: none;
            background-color: #f5f5f5;
            border-radius: 1rem;
            font-size: 1.4rem;
            &:focus {
                border: none;
            }
        }
        .ipt {
            position: relative;
            .iconfont {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 1.5rem;
                width: 2rem;
                height: 2rem;
                cursor: pointer;
                background-position: 0 0;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                background-image: url('../../assets/bx/eye-close.png');
                &.icon-eye-close {
                    background-image: url('../../assets/bx/eye-open.png');
                }
            }
        }
        .confirm {
            width: 100%;
            height: 3.2rem;
            background-color: #F66F30;
            color: #fff;
            font-size: 1.6rem;
            border-radius: 10rem;
            border: none;
            outline: none;
            &:disabled {
                background-color: #999;
                opacity: 1;
            }
        }
    }
}
</style>

